import { ref } from 'vue'

const STORAGE_KEY = 'dss_sidebar_history'
const MAX_ITEMS = 10

function loadHistory() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
  }
  catch {
    return []
  }
}

function saveHistory(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  }
  catch {}
}

export function useSearchHistory() {
  const recentItems = ref(loadHistory())

  function recordVisit(item) {
    if (!item?.label || !item?.route)
      return
    const entry = { label: item.label, originalKey: item.originalKey }
    recentItems.value = [
      entry,
      ...recentItems.value.filter(recent => recent.label !== entry.label),
    ].slice(0, MAX_ITEMS)
    saveHistory(recentItems.value)
  }

  function getSuggestion(query) {
    const trimmed = query?.trim()
    if (!trimmed)
      return null
    const lower = trimmed.toLowerCase()
    const match = recentItems.value.find(item =>
      item.label.toLowerCase().startsWith(lower) && item.label.length > trimmed.length,
    )
    return match ? match.label : null
  }

  return { recordVisit, getSuggestion }
}
